import { useEffect, useState } from 'react'
import { avatarInitial, avatarPalette, avatarStyle } from '../lib/avatarColor.js'

// Single source of truth for user avatar rendering: shows the uploaded photo
// when `avatarUrl` is set (and loads), otherwise the generative initial+palette
// treatment. An `onError` on the image falls back to generative so a stale URL
// (e.g. avatar removed on another device) never shows a broken image.
export function Avatar({
  avatarUrl,
  seed,
  displayName,
  sizeClass,
  locale = 'zh',
  testId,
}: {
  avatarUrl?: string
  seed: string
  displayName: string
  sizeClass: string
  locale?: 'zh' | 'en'
  testId?: string
}) {
  const [failed, setFailed] = useState(false)
  useEffect(() => setFailed(false), [avatarUrl])

  if (avatarUrl && !failed) {
    return (
      <img
        src={avatarUrl}
        alt={displayName}
        className={`${sizeClass} flex-none rounded-full border object-cover`}
        data-testid={testId}
        onError={() => setFailed(true)}
      />
    )
  }

  return (
    <div
      className={`${sizeClass} flex flex-none items-center justify-center rounded-full border font-semibold`}
      style={avatarStyle(avatarPalette(seed))}
      data-testid={testId}
      aria-hidden="true"
    >
      {avatarInitial(displayName, locale)}
    </div>
  )
}
